(() => {
  "use strict";
  const A = window.Artivana = window.Artivana || {};
  A.bridge = window.ARTIVANA_SHOPIFY || {};
  const fallback = Array.isArray(window.ARTIVANA_PRODUCTS) ? window.ARTIVANA_PRODUCTS : [];
  const source = A.bridge.enabled && Array.isArray(A.bridge.products) && A.bridge.products.length ? A.bridge.products : fallback;
  A.root = document.getElementById("root");
  A.q = (s, b = document) => b.querySelector(s);
  A.qa = (s, b = document) => Array.from(b.querySelectorAll(s));
  A.clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  A.money = (v) => `$${Number(v || 0).toFixed(0)}`;
  A.esc = (v) => String(v ?? "").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[c]));
  A.icon = (name) => {
    if (name === "sun") return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" stroke-linecap="round"/></svg>`;
    if (name === "close") return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>`;
    if (name === "left") return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M15 6l-6 6 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    if (name === "right") return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12.5l4.5 4.5L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  };
  const lastWord = v => {
    const words = String(v || "Artivana Piece").trim().split(/\s+/);
    return words[words.length - 1] || "Piece";
  };
  A.products = source.map((p, i) => {
    const name = String(p?.name || "Artivana Piece").trim();
    const rangeMin = Number(p?.rangeMin) || 0, rangeMax = Number(p?.rangeMax) || 0;
    return {...p,
      id:p?.id || `artivana-piece-${i+1}`, lot:p?.lot || `Piece ${String(i+1).padStart(2,"0")}`,
      code:p?.code || `AV-${String(i+1).padStart(3,"0")}`, name, nameItalic:p?.nameItalic || lastWord(name),
      material:p?.material || p?.productType || "Artivana", origin:p?.origin || "", maker:p?.maker || "",
      weight:p?.weight || "", dims:p?.dims || "", edition:p?.edition || "", blurb:p?.blurb || "",
      images:Array.isArray(p?.images) ? p.images.filter(Boolean) : [], stoneTone:p?.stoneTone || "dark",
      url:p?.url || "", priceMoney:p?.priceMoney || "", rangeMin, rangeMax, rangeStart:Number(p?.rangeStart)||0,
      guessEnabled:p?.guessEnabled === false ? false : rangeMin > 0 && rangeMax > rangeMin
    };
  });
  const nav = Array.isArray(A.bridge.navigation) && A.bridge.navigation.length ? A.bridge.navigation.filter(x=>x&&x.url) : [
    {title:"The Pieces",url:"#collection"},{title:"The Makers",url:"#makers"},{title:"Journal",url:"#journal"}
  ];
  A.leftNav = nav.filter(x=>!/^(basket|cart|artivana|home)$/i.test(String(x.title||"").trim())).slice(0,3);
  A.footerLinks = Array.isArray(A.bridge.footerLinks) ? A.bridge.footerLinks.filter(x=>x&&x.url) : [];
  A.overlay = null;
  A.closeOverlay = () => {
    if (A.overlay) A.overlay.remove();
    A.overlay = null;
    document.body.style.overflow = "";
  };
  addEventListener("keydown", e => { if (e.key === "Escape" && A.overlay) A.closeOverlay(); });
})();